import { useState, useCallback, useEffect } from 'react';
import { searchDefeitos } from '../services/defeitoService';

/**
 * Hook para gerenciar busca de defeitos
 * @param {{ codEquip?: string|null }} [options] - codprod do equipamento (modelo) para filtro no servidor quando a config estiver ativa
 */
export const useDefeitoSearch = (options = {}) => {
  const { codEquip = null } = options;
  const [defeitoSearch, setDefeitoSearch] = useState('');
  const [defeitoSuggestions, setDefeitoSuggestions] = useState([]);
  const [isLoadingDefeitos, setIsLoadingDefeitos] = useState(false);
  const [showSolucaoTooltip, setShowSolucaoTooltip] = useState(false);

  const fetchDefeitos = useCallback(
    async (searchTerm) => {
      if (!searchTerm || searchTerm.trim().length === 0) {
        setDefeitoSuggestions([]);
        return;
      }

      setIsLoadingDefeitos(true);
      try {
        const ce = codEquip != null && String(codEquip).trim() !== '' ? String(codEquip).trim() : null;
        const result = await searchDefeitos(searchTerm, ce);
        if (result.success) {
          setDefeitoSuggestions(result.items || []);
        } else {
          setDefeitoSuggestions([]);
        }
      } catch (error) {
        console.error('Erro ao buscar defeitos:', error);
        setDefeitoSuggestions([]);
      } finally {
        setIsLoadingDefeitos(false);
      }
    },
    [codEquip]
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (defeitoSearch && defeitoSearch.trim().length > 0) {
        fetchDefeitos(defeitoSearch);
      } else {
        setDefeitoSuggestions([]);
      }
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [defeitoSearch, fetchDefeitos]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSolucaoTooltip && !event.target.closest('[data-solucao-tooltip]')) {
        setShowSolucaoTooltip(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showSolucaoTooltip]);

  return {
    defeitoSearch,
    setDefeitoSearch,
    defeitoSuggestions,
    isLoadingDefeitos,
    showSolucaoTooltip,
    setShowSolucaoTooltip,
  };
};
